import React from "react";
import PlatformAnalyticsExperience from "./PlatformAnalyticsExperience";

/*
 * In-Game Analytics — served by the shared Platform Analytics experience. The
 * route, page title, report-link contract and topline data contract are
 * unchanged; the profile lives in
 * src/platformAnalytics/platformAnalyticsProfiles.js.
 *
 * ProgrammaticChannelAnalyticsPage offered no inventory-transparency module
 * for this channel, so none is claimed here.
 *
 * No connector reports In-Game creative-level delivery, so the profile declares
 * no creativePerformancePlatformKey and the Creative Performance section
 * renders its governed unsupported state rather than an empty grid.
 */
export default function InGameAnalytics() {
  return <PlatformAnalyticsExperience platformKey="ingame" />;
}
